import { Grid } from "@material-ui/core";
import { FoiItem } from "../../domain/FoiItem";
import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { DatePicker } from "@ofqual/portal-components/components/DatePicker";
import { Select } from "@ofqual/portal-components/components/Select";
import { fieldLabels } from "./fieldLabels";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { outcomeService } from "../../services";

export const OutcomeSection: React.FC<{
  sectionProps: SectionProps<FoiItem>;
}> = ({ sectionProps }) => {
  const { control, disabled } = sectionProps;

  const [outcomeLookups] = useLookup(outcomeService);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          name="internalReviewOutcomeId"
          as={
            <Select
              label={fieldLabels.internalReviewOutcomeId}
              data-test="internalReviewOutcomeId-field"
              readOnly={disabled}
            >
              {outcomeLookups}
            </Select>
          }
        />
        {/* {errors.internalReviewOutcomeId?.type === "required" && (
          <Error data-test="sourceId-validation">This field is required</Error>
        )} */}
      </Grid>

      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="icoDecisionNoticeId"
          as={
            <Select
              label={fieldLabels.icoDecisionNoticeId}
              data-test="icoDecisionNoticeId-field"
              readOnly={disabled}
            >
              {outcomeLookups}
            </Select>
          }
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Controller
          name="icoDateReceived"
          control={control}
          as={
            <DatePicker
              dataTest="icoDateReceived-picker"
              label={fieldLabels.icoDateReceived}
              readOnly={disabled}
            />
          }
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="firstTierTribunalOutcomeId"
          as={
            <Select
              label={fieldLabels.firstTierTribunalOutcomeId}
              data-test="firstTierTribunalOutcomeId-field"
              readOnly={disabled}
            >
              {outcomeLookups}
            </Select>
          }
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Controller
          name="firstTierTribunalOutcomeDate"
          control={control}
          as={
            <DatePicker
              dataTest="firstTierTribunalOutcomeDate-picker"
              label={fieldLabels.firstTierTribunalOutcomeDate}
              readOnly={disabled}
            />
          }
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="upperTierTribunalOutcomeId"
          as={
            <Select
              label={fieldLabels.upperTierTribunalOutcomeId}
              data-test="upperTierTribunalOutcomeId-field"
              readOnly={disabled}
            >
              {outcomeLookups}
            </Select>
          }
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Controller
          name="upperTierTribunalOutcomeDate"
          control={control}
          as={
            <DatePicker
              dataTest="upperTierTribunalOutcomeDate-picker"
              label={fieldLabels.upperTierTribunalOutcomeDate}
              readOnly={disabled}
            />
          }
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="courtOfAppealOutcomeId"
          as={
            <Select
              label={fieldLabels.courtOfAppealOutcomeId}
              data-test="courtOfAppealOutcomeId-field"
              readOnly={disabled}
            >
              {outcomeLookups}
            </Select>
          }
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Controller
          name="courtOfAppealOutcomeDate"
          control={control}
          as={
            <DatePicker
              dataTest="courtOfAppealOutcomeDate-picker"
              label={fieldLabels.courtOfAppealOutcomeDate}
              readOnly={disabled}
            />
          }
        />
      </Grid>
    </Grid>
  );
};
